import { render, staticRenderFns } from "./RepresentativeUpdate.vue?vue&type=template&id=277620bc&"
import script from "./RepresentativeUpdate.vue?vue&type=script&lang=ts&"
export * from "./RepresentativeUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports